import { WhitelabelEnum } from './../model/enum/whitelabel.enum';
import { ConfigService } from '@services/webFeeder/config.service';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpService } from '@services/http-service';
import { Constants } from '@utils/constants';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class RegisterService {

  constructor(
    private httpService: HttpService,
    private configService: ConfigService,
    private httpClient: HttpClient
  ) { }

  getAddressByPostalCode(zipCode: any): Observable<any> {
    if (zipCode) {
      return this.httpClient.get(
        this.configService.getViaCepUrl() + '/' +
        zipCode.replace('.', '').replace('-', ''));
    }

    return of()

  }

  getBrokerList(): Observable<any> {
    return this.httpClient.get(this.configService.getApiWebFeederRest() + '/services/broker/list');
  }

  mapFormToUserApi(dataSend) {

    let birthdate;
    if (moment.isMoment(dataSend.birthdate)) {
      dataSend.birthdate = dataSend.birthdate.format('YYYY-MM-DD')
    }else{
      dataSend.birthdate = moment(dataSend.birthdate).format('YYYY-MM-DD')
    }

    return {
      "password":  !!dataSend.password ? dataSend.password : null,
      "name": dataSend.full_name,
      "email": dataSend.email,
      "document": dataSend.document.replace(/\D/g, ""),
      "phone_number": dataSend.phone_number.replace(/\D/g, ""),
      "is_professional": dataSend.professional_investor_verified,
      "accepted_term_verified": dataSend.accepted_term_verified,
      "birthdate": dataSend.birthdate,
      "address": {
        "street": dataSend.address.street_address && dataSend.address.street_address.split(';;').length > 1 ? dataSend.address.street_address.split(';;')[0] : null,
        "neighborhood": dataSend.address.street_address && dataSend.address.street_address.split(';;').length >= 3 ? dataSend.address.street_address.split(';;')[3] : null,
        "number": dataSend.address.street_address && dataSend.address.street_address.split(';;').length >= 1 && /^\d+$/.test(dataSend.address.street_address.split(';;')[1]) ? dataSend.address.street_address.split(';;')[1] : null,
        "city": dataSend.address.locality,
        "state": dataSend.address.region,
        "postal_code": dataSend.address.postal_code,
        "country": "BR"
      }
    }
  }

  registerClient(objToPost: any, broker?: string) {
    if (broker && broker.toString().toLowerCase() !== 'mercbitcoin') {
      return this.httpClient.post(this.configService.getApiWebFeederRest() +
        '/services/register/clients/' + broker.toString().toUpperCase() + '/sinacor', objToPost);
    }

    if (!!!broker && this.configService.registerGoToIdentity()) {
      let dataSend = this.mapFormToUserApi(objToPost);
      return this.httpClient.post(this.configService.getUserApiUrl() + '/users', dataSend,{
        headers: {
          "X-Registration-Settings-Key": "FASTTRADE"
        }
      });
    } else {
      const objFacade = {
        name: objToPost.full_name,
        cpf: objToPost.document,
        professional: objToPost.professional_investor_verified,
        acepted_term: objToPost.accepted_term_verified,
        email: objToPost.email,
        phone: objToPost.phone_number,
        zip_code: objToPost.address.postal_code,
        address: objToPost.address.street_address && objToPost.address.street_address.split(';;').length > 1 ? objToPost.address.street_address.split(';;')[0] : null,
        number: objToPost.address.street_address && objToPost.address.street_address.split(';;').length >= 1 && /^\d+$/.test(objToPost.address.street_address.split(';;')[1])
          ? Number(objToPost.address.street_address.split(';;')[1]) : null,
        neighborhood: objToPost.address.street_address && objToPost.address.street_address.split(';;').length >= 3
          ? objToPost.address.street_address.split(';;')[3] : null,
        city: objToPost.address.locality,
        state: objToPost.address.region,
        broker_simulator: objToPost.broker ? objToPost.broker : this.configService.getBroker(),
        birth_date: objToPost.birthdate ? new Date(objToPost.birthdate).toLocaleDateString() : null,
      };
      return this.httpClient.post(this.configService.getApiWebFeederRest() + '/services/register/clients/market_data', objFacade);
    }
  }
}
